module.exports = __webpack_public_path__ + "img/3.54b29587.jpg";